module.exports = {
	"id": "BA",
	"name": "Bosnia and Herzegovina",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.029445,
			"12": 0.005889,
			"13": null,
			"14": 0.005889,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.082446,
			"23": 0.005889,
			"24": null,
			"25": 0.017667,
			"26": 0.064779,
			"27": 0.005889,
			"28": null,
			"29": 0.005889,
			"30": 0.023556,
			"31": 0.035334,
			"32": 0.011778,
			"33": 0.029445,
			"34": 0.100113,
			"35": 0.017667,
			"36": 0.017667,
			"37": 0.017667,
			"38": 0.053001,
			"39": 0.047112,
			"40": 0.023556,
			"41": 0.017667,
			"42": 0.017667,
			"43": 0.094224,
			"44": 0.05889,
			"45": 0.041223,
			"46": 0.047112,
			"47": 0.182559,
			"48": 0.076557,
			"49": 4.469751,
			"50": 0.082446,
			"51": 0.359229,
			"52": 0.323895,
			"53": 27.772524,
			"54": 7.720479,
			"55": 0.100113,
			"56": 0.023556,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.035334,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.005889,
			"13": null,
			"14": 0.011778,
			"15": 0.023556,
			"16": 0.011778,
			"17": 0.011778,
			"18": 0.011778,
			"19": null,
			"20": 0.011778,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.005889,
			"29": null,
			"30": 0.011778,
			"31": 0.023556,
			"32": null,
			"33": 0.005889,
			"34": 0.011778,
			"35": 0.023556,
			"36": 0.011778,
			"37": 0.035334,
			"38": 0.047112,
			"39": 0.041223,
			"40": 0.035334,
			"41": 0.053001,
			"42": 0.041223,
			"43": 0.129558,
			"44": 0.035334,
			"45": 0.194337,
			"46": 0.076557,
			"47": 0.394563,
			"48": 0.335673,
			"49": 8.179821,
			"50": 0.153114,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.011778
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.017667,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.005889,
			"35": 0.011778,
			"36": 0.11778,
			"37": 0.053001,
			"38": 0.035334,
			"39": 0.017667,
			"40": 0.995241,
			"41": 0.159003,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.047112
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.005889,
			"6": null,
			"7": 0.005889,
			"8": 0.023556,
			"9": 0.047112,
			"10": 0.253227,
			"3.1": null,
			"3.2": null,
			"5.1": 0.017667,
			"6.1": 0.011778,
			"7.1": null,
			"9.1": 0.153114
		},
		"ios_saf": {
			"8": 0,
			"10": 2.74563112989,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0739915819109,
			"8.1-8.4": 0.136696312344,
			"9.0-9.2": 0.0652129196503,
			"9.3": 0.994915056203
		},
		"android": {
			"3": 0,
			"4": 0.0988233410853,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0123529176357,
			"4.1": 0.356469908915,
			"4.2-4.3": 0.891174772287,
			"4.4": 2.04352551744,
			"4.4.3-4.4.4": 2.06117254264
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.100113,
			"9": 0.064779,
			"10": 0.106002,
			"11": 1.554696,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0195618749844,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000543385416233
		},
		"edge": {
			"12": 0.041223,
			"13": 0.217893,
			"14": 0.488787
		},
		"ie_mob": {
			"10": 0.203465549296,
			"11": 0.828395450704
		},
		"bb": {
			"7": 0.0061665,
			"10": null
		},
		"samsung": {
			"0": 1.706065
		},
		"and_uc": {
			"0": 0.057554
		},
		"op_mini": {
			"0": 0.263553739599
		},
		"and_chr": {
			"0": 29.70038
		},
		"and_ff": {
			"0": 0.020555
		}
	},
	"total": 98.8088285
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BA.json
 ** module id = 471
 ** module chunks = 0
 **/